import OnboardingStepper from "./OnboardingStepper";

export default OnboardingStepper;
